import React, { HTMLAttributes } from 'react';

import { Container } from './styles';

const Card: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...rest
}) => <Container {...rest}>{children}</Container>;

export default Card;
